import { AppDispatch, persistor } from "../store";
import { logout } from "../store/slices/authSlice";

const LOGOUT_IN_PROGRESS_KEY = "oidc_logout_in_progress_at";
const LOGOUT_IN_PROGRESS_TTL_MS = 2 * 60 * 1000;

export const logoutAndClearStorage = () => (dispatch: AppDispatch) => {
  dispatch(logout());
  persistor.purge();
};

export const setLogoutInProgress = () => {
  localStorage.setItem(LOGOUT_IN_PROGRESS_KEY, String(Date.now()));
};

export const clearLogoutInProgress = () => {
  localStorage.removeItem(LOGOUT_IN_PROGRESS_KEY);
};

export const isLogoutInProgress = () => {
  const raw = localStorage.getItem(LOGOUT_IN_PROGRESS_KEY);
  if (!raw) {
    return false;
  }

  const startedAt = Number(raw);
  if (!Number.isFinite(startedAt)) {
    clearLogoutInProgress();
    return false;
  }

  if (Date.now() - startedAt > LOGOUT_IN_PROGRESS_TTL_MS) {
    clearLogoutInProgress();
    return false;
  }

  return true;
};

/**
 * True when the current URL carries an OIDC authorization response. Checked by
 * path-independent callers because redirect_uri is deployment configuration: if
 * it points somewhere that never redeems the code, the app would bounce back to
 * Keycloak forever.
 */
export const isOidcCallbackUrl = () => {
  const params = new URLSearchParams(window.location.search);

  return params.has('code') && params.has('state');
};

// getUserInitials moved to Initials.util.ts — it is a pure display helper and
// this module's redux-store import made it untestable.
